export default __webpack_public_path__ + "static/media/tick-icon-blue.44217ab6.svg";